import React from "react";
import { AccountClass } from "@common/constants/domains/accounting/accounts";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";

const options: FilterMultiselectOption[] = Object.values(AccountClass).map(
    (accountClass) => ({
        value: accountClass,
        label: accountClass,
        searchableLabel: accountClass,
    }),
);

export const LedgerGroupFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const accountClasses = filters.accountClasses ?? [];

    return (
        <FilterMultiselect
            inDropdown={false}
            searchable={false}
            options={options}
            value={accountClasses}
            onChange={(val) => {
                onChange({
                    accountClasses:
                        val.length > 0 ? (val as AccountClass[]) : undefined,
                });
            }}
            name="accountClasses"
            onBlur={noop}
        />
    );
};
